import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'core/routing';

import { Section } from 'legacyComponents/layout/section';

import Tag from './Tag';

const tagsListMock = [
  {
    name: '#CNC',
    paramName: 'channel',
    param: 'cnc',
  },
  {
    name: '#Robotics',
    paramName: 'channel',
    param: 'robotics',
  },
  {
    name: '#3dprinting',
    paramName: 'channel',
    param: '3dprinting',
  },
  {
    name: '#Education',
    paramName: 'channel',
    param: 'education',
  },
  {
    name: '#Lasercutting',
    paramName: 'channel',
    param: 'lasercutting',
  },
  {
    name: '#Arduino',
    paramName: 'channel',
    param: 'arduino',
  },
  {
    name: '#Electronics',
    paramName: 'channel',
    param: 'electronics',
  },
  {
    name: '#Furniture',
    paramName: 'channel',
    param: 'furniture',
  },
];

const ListItems = props =>
  props.list.map(obj => {
    return (
      <Link name={obj.paramName} params={{ channel: obj.param }} key={obj.name}>
        <Tag tag={obj.name} />
      </Link>
    );
  });

export default function TagList(props) {
  return (
    <Section title='Trending Topics' gridColumns={2}>
      <ListItems list={props.list} />
    </Section>
  );
}

TagList.defaultProps = {
  list: tagsListMock,
};

TagList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object),
};
